import { fetchJourneyMasters } from "./journeyMasterService";
import { journeyActions } from "../store/journeySlice";

const getMasterItems = (response) => {
  if (response?.items && Array.isArray(response.items)) {
    return response.items;
  }

  if (Array.isArray(response)) {
    return response;
  }

  return [];
};

export const fetchJourneyMastersCached =
  (masterType, filter) => async (dispatch, getState) => {
    const state = getState();
    const cache = state.journey.apiCache?.[masterType];

    // If already cached return cached. Relationship rows saved before
    // showRelationInNomineeOrAppointee existed must be fetched again, or the
    // nominee dropdown filters every row out and stays on "Loading...".
    const staleRelationshipCache =
      masterType === "relationshipdetails" &&
      Array.isArray(cache?.data) &&
      !cache.data.some(
        (row) =>
          row != null &&
          Object.prototype.hasOwnProperty.call(
            row,
            "showRelationInNomineeOrAppointee",
          ),
      );
    // Occupation rows saved before eligibleJourneyOption existed must be
    // fetched again, or the journey filter hides every row.
    const staleOccupationTypeCache =
      masterType === "OccupationType" &&
      Array.isArray(cache?.data) &&
      cache.data.length > 0 &&
      !cache.data.some(
        (row) =>
          row != null &&
          Object.prototype.hasOwnProperty.call(row, "eligibleJourneyOption"),
      );
    if (cache?.data && !staleRelationshipCache && !staleOccupationTypeCache) {
      return cache.data;
    }

    // Otherwise return from API
    const response = await fetchJourneyMasters(masterType, filter);

    // Backend returns { masterType, items, totalCount }
    const items = getMasterItems(response);

    // Store in Redux cache
    dispatch(
      journeyActions.setApiCache({
        key: masterType,
        data: items,
      }),
    );

    return items;
  };
